/**
 * Generates a Ritz-Carlton hotel details URL with the provided parameters
 * @param {Object} params - The hotel parameters
 * @param {string} params.marshaCode - The 5-letter MARSHA property code (required)
 * @param {string} params.propertyName - The full property name (required)
 * @returns {string} The generated Ritz-Carlton hotel details URL
 */
export const generateRitzCarltonDetailsLink = (params) => {
  const { marshaCode, propertyName } = params;

  // Validate required parameters
  if (!marshaCode || !propertyName) {
    throw new Error("marshaCode and propertyName are required parameters");
  }

  // Convert property name to URL-friendly format
  // - Convert to lowercase
  // - Replace spaces and special characters with hyphens
  // - Remove multiple consecutive hyphens
  // - Remove leading/trailing hyphens
  const urlFriendlyName = propertyName
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // Remove special characters except spaces and hyphens
    .replace(/[\s]+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens

  // Construct the final URL
  const baseUrl = "https://www.ritzcarlton.com/en/hotels";
  return `${baseUrl}/${marshaCode.toLowerCase()}-${urlFriendlyName}/overview/`;
};